<template>
    <div class="pr-md-4 pl-md-4 pl-3 pr-3">
        <div class="language-nav">
            <div v-if="hasLanguageNavigationItems" class="">
                <ul class="lang-nav">
                    <li v-for="item in languageNavigationItems"
                        :key="item.id"
                        itemscope="itemscope"
                        itemtype="https://www.schema.org/SiteNavigationElement"
                        class="noble-gift-link menu-item nav-item"
                    >
                        <a :title="item.link.title" :href="item.link.href" class="nav-link" target="_blank">
                            <img
                                :src="require(`../../../assets/images/flags/${item.flag.filename}`)"
                                :alt="item.flag.alt"
                                class="flag"
                            >&nbsp;<span>{{ item.link.text }}</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>

        <Heading v-html="configData.headerText"/>
        <Subheading v-html="configData.mainText" />

        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li :class="{'one-time-payment': true, 'nav-item': true, 'active': isActive('/') }">
                <router-link to="/" class="nav-link">
                    <span class="svg-icon">
                        <svg class="svg-custom" viewBox="0 0 15 14" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.50407 12.5556L1.98727 7.23298C-1.011 4.0394 3.39645 -2.09226 7.50407 2.86842C11.6117 -2.09226 15.9992 4.0607 13.0209 7.23298L7.50407 12.5556Z" stroke-width="1.5" class="heart"/>
                        </svg>
                    </span>
                    <span class="text">Wpłacam<br class="d-none d-xs-block"> jednorazowo</span>
                </router-link>
            </li>
            <li :class="{'monthly-payment': true, 'nav-item': true, 'active': isActive('/co-miesiac/') }">
                <router-link to="/co-miesiac/" class="nav-link">
                    <span class="svg-icon">
                        <svg class="svg-custom" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.5023 25.027L16.5028 21.2287C14.3292 18.9496 17.5244 14.5738 20.5023 18.114C23.4802 14.5738 26.661 18.9648 24.5018 21.2287L20.5023 25.027Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="heart"/>
                            <path d="M31.9611 12.7705L30.6284 16.7685L26.6303 15.4358" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="top-arrows"/>
                            <path d="M9.64378 19.0041C10.4124 13.3823 15.398 9.21687 21.1557 9.56241C25.5623 9.82691 29.2039 12.6609 30.7109 16.5198" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="top-arrows"/>
                            <path d="M31.3552 21.996C30.5866 27.6178 25.601 31.7833 19.8434 31.4377C15.437 31.1733 11.7955 28.3396 10.2885 24.4811" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="bottom-arrows"/>
                            <path d="M9.03845 28.2299L10.3711 24.2318L14.3693 25.5645" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="bottom-arrows"/>
                        </svg>
                    </span>
                    <span class="text">Wpłacam<br class="d-none d-xs-block"> co&nbsp;miesiąc</span>
                </router-link>
            </li>
            <li class="nav-tabs-shadow"></li>
        </ul>

      <keep-alive include="OneTimePaymentStepOne,MonthlyPaymentStepOne">
        <router-view class="row3" />
      </keep-alive>
    </div>
</template>

<script>
import Heading from '@/components/atoms/Heading'
import Subheading from '@/components/atoms/Subheading'
import paymentTypes from '../../../constants/paymentTypes'
import { mapGetters } from 'vuex'
import _ from "lodash";
import {connectToSession} from "../../../helpers/connectToSession";

export default {
    name: 'NestedPages',
    components: {
        Subheading,
        Heading
    },
    computed: {
        ...mapGetters([
            'configData',
        ]),
        currentAmount: {
          get () {
            return this.$store.state.currentAmount
          },
          set (newValue) {
            this.$store.commit('setCurrentAmount', newValue)
            sessionStorage.setItem('amount', newValue)
          }
        },
        amountList: {
          get() {
            return this.$store.state.amountList
          },
          set(newValue) {
            this.$store.commit('setAmountList', newValue)
          }
        },
        hasLanguageNavigationItems () {
            return this.$store.state.configData.hasLanguageNavigationItems
        },
        languageNavigationItems () {
            return this.$store.state.configData.languageNavigationItems
        }
    },
    methods: {
        isActive (path) {
            return this.$route.path === path
        },
        setDataFromUrl () {
          const urlSearch = new URLSearchParams(window.location.search)
          const amount = urlSearch.get('amount')

          if (amount !== null) {
            this.currentAmount = amount
          }
        },
        setDataFromConfig() {
            const defaultAmount = this.configData.defaultAmount
            const defaultAmounts = this.configData.defaultAmounts
            const paymentTilesOrder = this.configData.paymentTilesOrder

            if (defaultAmounts && defaultAmounts.length === 3) {
                let update = true;
                for (let i in defaultAmounts) {
                    if (false === Number.isInteger(defaultAmounts[i])) {
                        update = false;
                        break;
                    }
                }
                if (update) {
                    this.amountList = defaultAmounts;
                }
            }

            if (true === Number.isInteger(defaultAmount)) {
                this.currentAmount = defaultAmount
            }

            if (Array.isArray(paymentTilesOrder) && (this.amountList.length === 0 || _.isEqual(_.sortBy(this.amountList), _.sortBy(paymentTilesOrder)))) {
                this.amountList = paymentTilesOrder
            }
        }
    },
    created () {
        let storedAmount = sessionStorage.getItem('amount');

        if (typeof (storedAmount) !== 'undefined' && storedAmount !== null) {
            this.currentAmount = storedAmount;
        }

        // save testcafe state
        let testcafe = sessionStorage.getItem('X-TestCafe');

        sessionStorage.clear()

        // restore testcafe state
        sessionStorage.setItem('X-TestCafe', testcafe)

        this.setDataFromConfig()
        this.setDataFromUrl()

        connectToSession.dataToSessionStorage(
            this.currentAmount,
            this.amountList,
            this.paymentType,
            this.$store.state.paymentMethod,
            process.env.VUE_APP_PAYMENT_FORM_NAME,
            process.env.VUE_APP_SUCCESS_URL,
            process.env.VUE_APP_FAILURE_URL,
            process.env.VUE_APP_SUCCESS_DIRECT_URL,
            (new URLSearchParams(window.location.search)).get('partner'),
        )
    },
}
</script>

<style scoped>
.flag {
    width: 24px;
    height: 12px;
}
</style>
